// extracted by mini-css-extract-plugin
export var aboveInput = "_nh-0";
export var actionButton = "_nh-5";
export var actionButtonContainer = "_nh-1";
export var actionIcon = "_nh-6";
export var aiInfoContainer = "_nh-2";
export var attachmentWrapper = "_nh-7";
export var bold = "_nh-3";
export var checkIcon = "_nh-8";
export var clickingRecipientBar = "_nh-11";
export var commentThreadSwitch = "_nh-a";
export var draftImage = "_nh-b";
export var draftImageContainer = "_nh-c";
export var draftImages = "_nh-e";
export var editButton = "_nh-g";
export var editor = "_nh-f";
export var editorContainer = "_nh-y";
export var editorErrorTooltipWrapper = "_nh-9";
export var headerDivider = "_nh-h";
export var icon = "_nh-i";
export var info = "_nh-j";
export var internal = "_nh-n";
export var internalDivider = "_nh-k";
export var internalMessage = "_nh-l";
export var messageInputCard = "_nh-m";
export var messageInputForm = "_nh-o";
export var messageInputFormInternal = "_nh-p";
export var options = "_nh-q";
export var publicMessageCustomer = "_nh-s";
export var publicMessageMerchant = "_nh-r";
export var removeImageButton = "_nh-d";
export var replyButtons = "_nh-t";
export var showSignatureButton = "_nh-u";
export var spinner = "_nh-v";
export var verticalButtonDivider = "_nh-4";
export var visibilitySelector = "_nh-w";
export var warning = "_nh-x";
export var wrappingText = "_nh-z";
export var writingInternalNoteTopBorder = "_nh-10";